import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NewsCard from "@/components/feature/NewsCard";
import SectionTitle from "@/components/feature/SectionTitle";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { getNewsById, getRelatedNews } from "@/lib/content";

export default function NewsDetailPage() {
  const { id } = useParams();
  const article = getNewsById(id);

  useDocumentMeta({
    title: article ? `${article.title} - 影视资讯 - 国语对白做受69` : "资讯不存在 - 国语对白做受69",
    description: article ? article.summary : "抱歉，你访问的影视资讯不存在或已下架，请返回资讯列表浏览其他内容。",
    keywords: article ? `${article.title},${article.category},影视资讯,国语对白做受69` : "影视资讯",
  });

  if (!article) {
    return (
      <Layout>
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-24 text-center">
          <span className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
            <i className="ri-file-text-line text-4xl"></i>
          </span>
          <h1 className="mt-6 text-xl md:text-2xl font-bold text-foreground-900 font-heading">资讯不存在</h1>
          <p className="mt-2 text-sm text-foreground-500">你访问的资讯可能已被移除，或链接有误。</p>
          <Link
            to="/news"
            className="mt-6 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-600 text-background-50 text-sm font-medium hover:bg-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </div>
      </Layout>
    );
  }

  const related = getRelatedNews(article.id, 3);

  return (
    <Layout>
      <div className="w-full bg-primary-950">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-5">
          <nav className="text-xs md:text-sm text-background-400 flex items-center gap-1.5 flex-wrap">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/news" className="hover:text-accent-400 transition-colors cursor-pointer">
              影视资讯
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-400 line-clamp-1">{article.title}</span>
          </nav>
        </div>
      </div>

      <article className="w-full max-w-[860px] mx-auto px-4 md:px-8 py-8 md:py-12">
        <div className="flex items-center gap-2 flex-wrap mb-4">
          <span className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-900 text-xs">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading leading-snug">
          {article.title}
        </h1>
        <p className="mt-3 text-xs text-foreground-400">
          来源：{article.source} · 作者：{article.author}
        </p>

        <div className="mt-6 rounded-lg overflow-hidden border border-background-200 bg-background-100">
          <img
            src={article.thumbnail}
            alt={article.title}
            title={`${article.title} - 影视资讯`}
            className="w-full h-56 md:h-80 object-cover object-top"
          />
        </div>

        <div className="mt-8 space-y-5">
          {article.content.map((paragraph, index) => (
            <p key={index} className="text-sm md:text-base text-foreground-700 leading-loose">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-200">
          <Link
            to="/news"
            className="inline-flex items-center gap-1.5 text-sm text-primary-600 hover:text-accent-600 transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            返回资讯列表
          </Link>
        </div>

        <section className="mt-12">
          <SectionTitle icon="ri-links-line" title="相关资讯" subtitle="你可能也感兴趣的内容" moreTo="/news" />
          <div className="space-y-3">
            {related.map((item) => (
              <NewsCard key={item.id} article={item} />
            ))}
          </div>
        </section>
      </article>
    </Layout>
  );
}